/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GamificationParticipationResponse
 */
export interface GamificationParticipationResponse {
    /**
     * Per-user type-specific state (e.g., completedTileIds for BINGO)
     * @type {{ [key: string]: any; }}
     * @memberof GamificationParticipationResponse
     */
    userState: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof GamificationParticipationResponse
     */
    completed: boolean;
    /**
     * 
     * @type {number}
     * @memberof GamificationParticipationResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GamificationParticipationResponse
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the GamificationParticipationResponse interface.
 */
export function instanceOfGamificationParticipationResponse(value: object): value is GamificationParticipationResponse {
    if (!('userState' in value) || value['userState'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GamificationParticipationResponseFromJSON(json: any): GamificationParticipationResponse {
    return GamificationParticipationResponseFromJSONTyped(json, false);
}

export function GamificationParticipationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationParticipationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userState': json['userState'],
        'completed': json['completed'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GamificationParticipationResponseToJSON(json: any): GamificationParticipationResponse {
    return GamificationParticipationResponseToJSONTyped(json, false);
}

export function GamificationParticipationResponseToJSONTyped(value?: GamificationParticipationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userState': value['userState'],
        'completed': value['completed'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

